// extracted by mini-css-extract-plugin
module.exports = {"primitive":"DetailedPrimitive_primitive__id0oQ article-wrapper text"};